module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.e2af09f8.mp3";